import {
  createContext,
  FC,
  PropsWithChildren,
  SetStateAction,
  useState,
} from "react";

interface ILoginInfo {
  userId: string;
  restourantId: string;
  expiration: string;
  secretKey: string;
  token: string;
  setName: React.Dispatch<React.SetStateAction<ILoginInfo>>;
}

export const Context = createContext<ILoginInfo>({
  userId: "",
  restourantId: "",
  expiration: "",
  secretKey: "",
  token: "",
  setName: () => {},
});

export const AppContext: FC<PropsWithChildren> = (props) => {
  const [loginInfo, setName] = useState<ILoginInfo>({
    userId: "",
    restourantId: "",
    expiration: "",
    secretKey: "",
    token: "",
    setName: () => {}, // Placeholder, context sağlayınca gerçek setName kullanılacak
  });

  const sendObj = { ...loginInfo, setName };

  return <Context.Provider value={sendObj}>{props.children}</Context.Provider>;
};
